module.exports = __webpack_public_path__ + "img/bloom_light_natural_ba_detail_rsh_2.2a040d40.jpg";